export const INDIAN_STATES_AND_CITIES = {
  "Gujarat": [
    "Surat",
    "Ahmedabad",
    "Vadodara",
    "Rajkot",
    "Bhavnagar",
    "Jamnagar",
    "Gandhinagar",
    "Junagadh",
    "Anand",
    "Navsari",
    "Morbi",
    "Bharuch",
    "Valsad",
    "Vapi",
    "Porbandar",
    "Godhra",
    "Bhuj",
    "Ankleshwar",
    "Surendranagar",
    "Patan",
    "Mehsana",
    "Palanpur",
    "Veraval",
    "Dahod",
    "Botad",
    "Amreli",
    "Deesa",
    "Jetpur",
    "Gondal",
    "Somnath",
    "Gandhidham",
    "Bardoli",
    "Vyara",
    "Bilimora",
    "Mandvi",
    "Kalol",
    "Sanand",
    "Kadi",
    "Halol",
    "Modasa",
    "Himatnagar",
    "Keshod",
    "Wankaner",
    "Unjha"
  ],
  "Maharashtra": [
    "Mumbai",
    "Pune",
    "Nagpur",
    "Thane",
    "Nashik",
    "Chhatrapati Sambhajinagar",
    "Solapur",
    "Kolhapur",
    "Navi Mumbai",
    "Amravati",
    "Jalgaon",
    "Akola",
    "Latur",
    "Dhule",
    "Ahmednagar",
    "Chandrapur",
    "Parbhani",
    "Ichalkaranji",
    "Jalna",
    "Nanded",
    "Satara",
    "Sangli",
    "Malegaon",
    "Panvel",
    "Bhiwandi"
  ],
  "Delhi": [
    "New Delhi",
    "Central Delhi",
    "North Delhi",
    "South Delhi",
    "East Delhi",
    "West Delhi",
    "Rohini",
    "Dwarka"
  ],
  "Rajasthan": [
    "Jaipur",
    "Jodhpur",
    "Kota",
    "Bikaner",
    "Ajmer",
    "Udaipur",
    "Bhilwara",
    "Alwar",
    "Bharatpur",
    "Sikar",
    "Pali",
    "Sri Ganganagar",
    "Chittorgarh",
    "Beawar",
    "Kishangarh",
    "Hanumangarh"
  ],
  "Madhya Pradesh": [
    "Indore",
    "Bhopal",
    "Jabalpur",
    "Gwalior",
    "Ujjain",
    "Sagar",
    "Dewas",
    "Satna",
    "Ratlam",
    "Rewa",
    "Katni",
    "Singrauli",
    "Burhanpur",
    "Khandwa",
    "Bhind",
    "Chhindwara",
    "Guna",
    "Shivpuri",
    "Vidisha",
    "Damoh",
    "Mandsaur",
    "Neemuch"
  ],
  "Uttar Pradesh": [
    "Lucknow",
    "Kanpur",
    "Varanasi",
    "Agra",
    "Meerut",
    "Prayagraj",
    "Bareilly",
    "Aligarh",
    "Moradabad",
    "Saharanpur",
    "Gorakhpur",
    "Noida",
    "Greater Noida",
    "Firozabad",
    "Jhansi",
    "Muzaffarnagar",
    "Mathura",
    "Ayodhya",
    "Ghaziabad",
    "Rampur",
    "Shahjahanpur",
    "Farrukhabad",
    "Hapur",
    "Etawah",
    "Mirzapur",
    "Bulandshahr"
  ],
  "Karnataka": [
    "Bengaluru",
    "Mysuru",
    "Hubballi-Dharwad",
    "Mangaluru",
    "Belagavi",
    "Davanagere",
    "Ballari",
    "Kalaburagi",
    "Shivamogga",
    "Tumakuru",
    "Bidar",
    "Hosapete",
    "Gadag-Betageri",
    "Hassan",
    "Vijayapura",
    "Raichur",
    "Udupi"
  ],
  "Tamil Nadu": [
    "Chennai",
    "Coimbatore",
    "Madurai",
    "Tiruchirappalli",
    "Salem",
    "Tiruppur",
    "Erode",
    "Vellore",
    "Tirunelveli",
    "Thoothukudi",
    "Dindigul",
    "Thanjavur",
    "Ranipet",
    "Sivakasi",
    "Karur",
    "Hosur",
    "Nagercoil",
    "Kanchipuram"
  ],
  "Telangana": [
    "Hyderabad",
    "Warangal",
    "Nizamabad",
    "Karimnagar",
    "Ramagundam",
    "Khammam",
    "Mahbubnagar",
    "Nalgonda",
    "Adilabad",
    "Suryapet",
    "Siddipet"
  ],
  "Andhra Pradesh": [
    "Visakhapatnam",
    "Vijayawada",
    "Guntur",
    "Nellore",
    "Kurnool",
    "Rajahmundry",
    "Tirupati",
    "Kakinada",
    "Kadapa",
    "Anantapur",
    "Vizianagaram",
    "Eluru",
    "Ongole",
    "Nandyal",
    "Machilipatnam",
    "Tenali",
    "Chittoor"
  ],
  "West Bengal": [
    "Kolkata",
    "Howrah",
    "Durgapur",
    "Asansol",
    "Siliguri",
    "Bardhaman",
    "Malda",
    "Kharagpur",
    "Haldia",
    "Habra",
    "Darjeeling",
    "Jalpaiguri"
  ],
  "Punjab": [
    "Ludhiana",
    "Amritsar",
    "Jalandhar",
    "Patiala",
    "Bathinda",
    "Mohali",
    "Hoshiarpur",
    "Pathankot",
    "Moga",
    "Batala",
    "Abohar",
    "Khanna",
    "Phagwara"
  ],
  "Haryana": [
    "Gurugram",
    "Faridabad",
    "Panipat",
    "Ambala",
    "Yamunanagar",
    "Rohtak",
    "Hisar",
    "Karnal",
    "Sonipat",
    "Panchkula",
    "Bhiwani",
    "Sirsa",
    "Bahadurgarh",
    "Jind",
    "Rewari"
  ],
  "Bihar": [
    "Patna",
    "Gaya",
    "Bhagalpur",
    "Muzaffarpur",
    "Purnia",
    "Darbhanga",
    "Bihar Sharif",
    "Arrah",
    "Begusarai",
    "Katihar",
    "Munger",
    "Chhapra",
    "Danapur",
    "Bettiah",
    "Hajipur"
  ],
  "Kerala": [
    "Thiruvananthapuram",
    "Kochi",
    "Kozhikode",
    "Kollam",
    "Thrissur",
    "Kannur",
    "Alappuzha",
    "Palakkad",
    "Kottayam",
    "Malappuram",
    "Kasaragod"
  ],
  "Goa": [
    "Panaji",
    "Margao",
    "Vasco da Gama",
    "Mapusa",
    "Ponda"
  ],
  "Chhattisgarh": [
    "Raipur",
    "Bhilai",
    "Bilaspur",
    "Korba",
    "Rajnandgaon",
    "Durg",
    "Jagdalpur",
    "Ambikapur",
    "Raigarh"
  ],
  "Jharkhand": [
    "Ranchi",
    "Jamshedpur",
    "Dhanbad",
    "Bokaro Steel City",
    "Deoghar",
    "Hazaribagh",
    "Giridih",
    "Ramgarh"
  ],
  "Odisha": [
    "Bhubaneswar",
    "Cuttack",
    "Rourkela",
    "Berhampur",
    "Sambalpur",
    "Puri",
    "Balasore",
    "Bhadrak",
    "Jharsuguda"
  ],
  "Assam": [
    "Guwahati",
    "Silchar",
    "Dibrugarh",
    "Jorhat",
    "Nagaon",
    "Tinsukia",
    "Tezpur",
    "Bongaigaon"
  ],
  "Uttarakhand": [
    "Dehradun",
    "Haridwar",
    "Roorkee",
    "Haldwani",
    "Rudrapur",
    "Kashipur",
    "Rishikesh",
    "Nainital"
  ],
  "Himachal Pradesh": [
    "Shimla",
    "Dharamshala",
    "Solan",
    "Mandi",
    "Kullu",
    "Manali",
    "Baddi",
    "Bilaspur"
  ],
  "Jammu and Kashmir": [
    "Srinagar",
    "Jammu",
    "Anantnag",
    "Baramulla",
    "Udhampur",
    "Kathua"
  ],
  "Chandigarh": [
    "Chandigarh"
  ],
  "Dadra and Nagar Haveli and Daman and Diu": [
    "Daman",
    "Diu",
    "Silvassa"
  ],
  "Ladakh": [
    "Leh",
    "Kargil"
  ],
  "Puducherry": [
    "Puducherry",
    "Karaikal",
    "Mahe",
    "Yanam"
  ],
  "Tripura": [
    "Agartala",
    "Dharmanagar",
    "Udaipur"
  ],
  "Meghalaya": [
    "Shillong",
    "Tura",
    "Jowai"
  ],
  "Manipur": [
    "Imphal",
    "Churachandpur",
    "Thoubal"
  ],
  "Mizoram": [
    "Aizawl",
    "Lunglei",
    "Champhai"
  ],
  "Nagaland": [
    "Kohima",
    "Dimapur",
    "Mokokchung"
  ],
  "Arunachal Pradesh": [
    "Itanagar",
    "Naharlagun",
    "Pasighat"
  ],
  "Sikkim": [
    "Gangtok",
    "Namchi",
    "Geyzing"
  ],
  "Andaman and Nicobar Islands": [
    "Port Blair"
  ],
  "Lakshadweep": [
    "Kavaratti",
    "Agatti"
  ]
};

export const getStateList = () => {
  const others = Object.keys(INDIAN_STATES_AND_CITIES).filter(s => s !== "Gujarat").sort();
  return ["Gujarat", ...others, "Other"];
};

export const getCitiesForState = (state) => {
  if (!state || state === "Other" || !INDIAN_STATES_AND_CITIES[state]) {
    return ["Other"];
  }
  return [...INDIAN_STATES_AND_CITIES[state], "Other"];
};

export const getStateOptions = (currentState) => {
  const list = getStateList();
  if (currentState && !list.includes(currentState)) {
    // Put current custom state before 'Other'
    const otherIdx = list.indexOf("Other");
    if (otherIdx !== -1) {
      list.splice(otherIdx, 0, currentState);
    } else {
      list.push(currentState);
    }
  }
  return list.map(s => ({ label: s, value: s }));
};

export const getCityOptions = (state, currentCity) => {
  const list = [...getCitiesForState(state)];
  if (currentCity && !list.includes(currentCity)) {
    const otherIdx = list.indexOf("Other");
    if (otherIdx !== -1) {
      list.splice(otherIdx, 0, currentCity);
    } else {
      list.push(currentCity);
    }
  }
  return list.map(c => ({ label: c, value: c }));
};
